import React, { lazy, Suspense } from 'react';

type DevtoolsComponent = React.ComponentType<{ initialIsOpen?: boolean }>;

const ReactQueryDevtools: DevtoolsComponent = import.meta.env.DEV
  ? lazy(() =>
      import('@tanstack/react-query-devtools').then((mod) => ({
        default: mod.ReactQueryDevtools,
      })),
    )
  : () => null;

export function ReactQueryDevtoolsGate() {
  if (!import.meta.env.DEV) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <ReactQueryDevtools initialIsOpen={false} />
    </Suspense>
  );
}
